import React, { useState, useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Fetching } from '../../../components/Fetching'
import { useNavigate } from 'react-router-dom'
import { ArrowBack, MapRounded } from '@mui/icons-material'
import * as Sentry from '@sentry/react'
import LocationPoint from '../../../types/LocationPoint'
import { Number } from 'aws-sdk/clients/iot'

export const GeoFence = (props: any) => {
  const { id } = useParams()
  const { selectedLocation } = props
  const [, setLat] = useState<any>(null)
  const [, setLng] = useState<any>(null)
  const [status, setStatus] = useState<any>('')
  const [loading, setLoading] = useState<any>(true)
  const navigate = useNavigate()

  const circularFenceInFeet = (
    uCoords: LocationPoint,
    pCoords: LocationPoint,
    radius: number
  ) => {
    const R = 209022.30971 // 63710 meters

    // console.log('uCoords: ', uCoords)
    // console.log('pCoords: ', pCoords)
    // console.log('radius: ', radius)

    const checkFence =
      Math.acos(
        Math.sin(pCoords.lat) * Math.sin(uCoords.lat) +
          Math.cos(pCoords.lat) *
            Math.cos(uCoords.lat) *
            Math.cos(uCoords.lng - pCoords.lng)
      ) *
        R <
      radius

    return checkFence
  }

  function getPosition(
    options?: PositionOptions
  ): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
    )
  }

  const checkWithinGeoFence = (
    position: GeolocationPosition,
    projectCoordinates: LocationPoint,
    radius: number
  ) => {
    if (
      !position ||
      !position.coords ||
      !position.coords.latitude ||
      !position.coords.longitude
    ) {
      // Send error to Sentry.io
      const lat = position.coords.latitude ? position.coords.latitude : null
      const long = position.coords.longitude ? position.coords.longitude : null
      Sentry.captureException(
        new Error(`Position coords are not defined, lat: ${lat}, long: ${long}`)
      )
      console.log(`Position coords are not defined, lat: ${lat}, long: ${long}`)
      setLoading(false)
      setStatus('No coordinates were returned.')
      return false
    }

    setLat(position.coords.latitude)
    setLng(position.coords.longitude)
    setLoading(true)
    const userCoordinates: LocationPoint = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    }

    // console.log('userCoordinates: ', userCoordinates)
    // console.log('projectCoordinates: ', projectCoordinates)
    // console.log('radius: ', radius)

    const isInsideGeoFence: boolean = circularFenceInFeet(
      userCoordinates,
      projectCoordinates,
      radius
    )
    return isInsideGeoFence
  }

  const getLocation = async (
    projectCoordinates: LocationPoint,
    radius: number
  ) => {
    if (!navigator.geolocation) {
      setLoading(false)
      setStatus('Your browser does not support geo location.')
      return
    }
    console.log('geo fence check.')
    // console.log('Project coordinates: ', projectCoordinates)
    try {
      const position = await getPosition({
        enableHighAccuracy: false,
        timeout: 30000,
        maximumAge: 0,
      })
      console.log('First position check: ', position)
      if (!checkWithinGeoFence(position, projectCoordinates, radius)) {
        setLoading(false)
        setStatus('You are inside the geo fence.')
        navigate(`/projects/${id}/select-worker`)
        // navigate(`/projects/${id}/match-worker`)
      } else {
        // Retry with high accuracy
        // console.log('Retrying geofence check')
        setTimeout(async () => {
          const position = await getPosition({
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 10000,
          })
          console.log('Retry position check: ', position)
          if (checkWithinGeoFence(position, projectCoordinates, radius)) {
            setLoading(false)
            setStatus('You are inside the geo fence.')
            navigate(`/projects/${id}/select-worker`)
          } else {
            setLoading(false)
            setStatus(
              'You are outside the geo fence. Make sure that the project has the correct address, or that you are at the correct location.'
            )
          }
        }, 500)
      }
    } catch (error: any) {
      setLoading(false)
      setStatus(
        `Error locating the geo fence. Make sure that location access is allowed by your browser. ${error.message}`
      )
      console.log(`Error occurred trying to get location. ${error.message}`)
      Sentry.captureException(error)
    }
  }

  useEffect(() => {
    if (selectedLocation) {
      const location = selectedLocation
      setLoading(true)
      // eslint-disable-next-line react-hooks/exhaustive-deps
      getLocation(
        { lat: location.latitude, lng: location.longitude },
        location.radius
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation])

  if (loading) {
    return (
      <Box sx={{ mt: 2, ml: 2, mr: 2 }}>
        <Typography
          variant='h5'
          gutterBottom
          sx={{ mb: 3, textAlign: 'center' }}>
          Verifying location
        </Typography>
        <Fetching />
      </Box>
    )
  }

  return (
    <>
      <Box sx={{ mt: 2, ml: 2, mr: 2 }}>
        <Typography
          variant='h5'
          gutterBottom
          sx={{ mb: 3, textAlign: 'center', verticalAlign: 'center' }}>
          <MapRounded /> Verifying location
        </Typography>
        <Box>{status}</Box>
        <Button
          variant='contained'
          onClick={() => navigate('/')}
          sx={{ marginBottom: 5, mt: 3 }}>
          <ArrowBack /> Back
        </Button>
      </Box>
    </>
  )
}
